<template>
  <router-view/>
</template>

<script>
export default {
  name: 'HowItWorks',
  data() {
    return {
      active: null,
    };
  },
};
</script>
